<template>
  <section
    v-bind="$attrs"
    class="-root"
    :style="{
      ...{
        padding,
        paddingLeft: 'var(--page-padding)',
        paddingRight: 'var(--page-padding)',
        gridTemplateRows:
          $slots.header || $slots.footer ? '1fr auto 1fr' : '0 1fr 0',
        gap: $slots.header || $slots.footer ? gap : '0',
      },
      ...$attrs.style,
    }"
  >
    <div class="-header">
      <slot name="header" />
    </div>
    <div class="-main" :style="{ gap }">
      <slot name="default" />
    </div>
    <div class="-footer">
      <slot name="footer" />
    </div>
  </section>
</template>

<style scoped lang="scss">
.-root {
  /* position: relative; */
  width: 100%;
  min-height: var(--vh);
  display: grid;
}

.-header,
.-footer,
.-main {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.-header {
  justify-content: start;
}
.-footer {
  justify-content: end;
}
</style>

<script setup>
defineOptions({ name: "CSection" });
defineProps({
  gap: { default: "2rem" },
  padding: { default: "4rem" },
});
</script>
